import { get, post } from '@api/request';

export async function fetchDashboardsByRole(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/dashboard/fetchbyrole`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchDashboardQueryResults(
  { appraisalService },
  authenticationToken,
  { dashboardQueryID, page = 1, pageSize = 1000 },
) {
  const url = `${appraisalService}/dashboard/configuration/query/${dashboardQueryID}/execute?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function executeDashboard(
  { appraisalService },
  authenticationToken,
  { dashboardID },
) {
  const url = `${appraisalService}/dashboard/configuration/${dashboardID}/execute`;
  const { body } = await post(authenticationToken, url, {});
  return body;
}
